import { useEffect } from "react";
import clsx from "clsx";

export default function Modal({ open, onClose, title, children, wide, fullscreen }) {
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else       document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      style={{ background: "rgba(0,0,0,0.75)", backdropFilter: "blur(10px)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={clsx(
          "w-full overflow-y-auto animate-slide-up relative",
          "rounded-t-3xl sm:rounded-3xl",
          fullscreen ? "max-h-[95dvh]" : "max-h-[88dvh]",
          wide ? "sm:max-w-3xl" : "sm:max-w-lg",
        )}
        style={{
          background:  "linear-gradient(135deg, rgba(13,13,43,0.98) 0%, rgba(9,9,32,0.99) 100%)",
          border:      "1px solid rgba(139,92,246,0.22)",
          boxShadow:   "0 -8px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.03) inset",
        }}
      >
        {/* Top edge glow */}
        <div
          className="absolute inset-x-0 top-0 h-px pointer-events-none rounded-t-3xl"
          style={{ background: "linear-gradient(90deg, transparent, rgba(139,92,246,0.5), rgba(6,182,212,0.3), transparent)" }}
        />

        {/* Mobile drag handle */}
        <div className="w-10 h-1 rounded-full mx-auto mt-3 sm:hidden" style={{ background: "rgba(139,92,246,0.3)" }} />

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-xl bg-nexus-s2 border border-nexus-border flex items-center justify-center text-gray-500 hover:text-white hover:bg-nexus-s3 hover:border-violet-500/30 transition-all duration-200 z-10 text-sm active:scale-90"
        >
          ✕
        </button>

        {title && (
          <div
            className="px-5 pt-5 pb-3"
            style={{ borderBottom: "1px solid rgba(139,92,246,0.12)" }}
          >
            <h2 className="text-lg font-black pr-8">{title}</h2>
          </div>
        )}

        <div className="p-5 scrollbar-hide">{children}</div>
      </div>
    </div>
  );
}
